<template>
  <div class="cartouchePublic">
    <div :class="window.width < 480 ? 'container-fluid' : 'container'">
      <div>
        <span
          style="font-size:24px; cursor:pointer"
          v-if="
            parameters === 'adminPage' ||
              parameters === 'adminDashboard' ||
              parameters === 'adminResultats' ||
              parameters === 'client'
          "
          @click="returnFunction()"
        >
          <img
            style="height:24px;"
            src="~@/assets/img/public_logo.png"
            alt="logo-sondage"
          />
          profeel
        </span>
        <div class="is-pulled-right" @click="searchBar()">
          <img
            v-if="parameters === 'adminPage'"
            style="cursor:pointer;width:18px;height:18px;"
            src="~@/assets/img/icons/searchbar-icon.png"
            alt="searchbar-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Header",
  props: {
    parameters: String,
    window: Object
  },
  computed: {
    ...mapGetters(["adminActiveComponents"])
  },
  methods: {
    returnFunction() {
      switch (this.parameters) {
        case "adminPage":
          this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
            cardList: true,
            parameters: false
          });
          break;
        case "adminDashboard":
          this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
            cardList: true,
            parameters: false
          });
          this.$router.push({ name: "Admin" });
          break;
        case "adminResultats":
          this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
            cardList: true,
            parameters: false
          });
          this.$router.push({ name: "Admin" });
          break;
        case "client":
          this.$router.replace({ name: "home" }).catch(err => {});
          break;
      }
    },
    searchBar() {
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        searchBar: !this.adminActiveComponents.searchBar,
        cardList: true
      });
    }
  }
};
</script>

<style scoped>
.cartouchePublic {
  background-color: #424a60;
  color: white;
  text-align: left;
  height: 40px;
  font-size: 24px;
  z-index: 1000;
  position: relative;
  line-height: 32px;
}

.cartouchePublic img {
  height: 24px;
  vertical-align: middle;
}
</style>
